var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['backbone', 'jquery', 'underscore', 'core', 'template/report/pagination.htm'], function(Backbone, $, _, core, paginationTemplate) {
  var PaginationMenuView;
  return PaginationMenuView = (function(_super) {

    __extends(PaginationMenuView, _super);

    function PaginationMenuView() {
      PaginationMenuView.__super__.constructor.apply(this, arguments);
    }

    PaginationMenuView.prototype.className = 'pagination__container';

    PaginationMenuView.prototype.currentPage = 1;

    PaginationMenuView.prototype.pageCount = 1;

    PaginationMenuView.prototype.events = {
      'click [pagination~="right"]': 'nextHandler',
      'click [pagination~="left"]': 'previousHandler',
      'click .pagination__number': 'pageNumHandler'
    };

    PaginationMenuView.prototype.render = function() {
      var $counter, $left, $right;
      if (this.$el.html().length === 0) {
        return this.$el.html(_.template(paginationTemplate, {
          pageCount: this.pageCount,
          currentPage: this.currentPage
        }));
      } else {
        $counter = this.$el.find('.pagination__counter');
        $right = this.$el.find('[pagination~="right"]');
        $left = this.$el.find('[pagination~="left"]');
        $counter.html("" + this.currentPage + "/" + this.pageCount);
        if (this.currentPage === 1) {
          $left.attr('pagination', 'left disabled');
        } else {
          $left.attr('pagination', 'left');
        }
        if (this.pageCount === this.currentPage) {
          return $right.attr('pagination', 'right disabled');
        } else {
          return $right.attr('pagination', 'right');
        }
      }
    };

    PaginationMenuView.prototype.setPageCount = function(pageCount) {
      this.pageCount = pageCount;
      if (this.pageCount === 0) {
        this.pageCount = 1;
      }
      return this.render();
    };

    PaginationMenuView.prototype.setPage = function(page, firePageChangeEvent) {
      if (firePageChangeEvent == null) {
        firePageChangeEvent = false;
      }
      if (!((1 <= page && page <= this.pageCount)) || page === this.currentPage) {
        return;
      }
      this.currentPage = page;
      this.render();
      if (firePageChangeEvent) {
        return this.trigger('page-change', {
          page: this.currentPage
        });
      }
    };

    PaginationMenuView.prototype.nextHandler = function() {
      return this.setPage(this.currentPage + 1, true);
    };

    PaginationMenuView.prototype.previousHandler = function() {
      return this.setPage(this.currentPage - 1, true);
    };

    return PaginationMenuView;

  })(Backbone.View);
});
